<template>
<div v-if="ready">
    <div ref="source">
        <table style="border: 1px solid lightgrey; border-radius: 5px; padding: 25px;" :class="$style.sourceTable">
            <thead>
                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'RÉSUMÉ DU PROFIL DU PATIENT' : 'SUMMARY OF PATIENT PROFILE'}}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'Profil du patient' : 'Patient Profile'}}
                    </th>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'CAT ou CRMm' : 'CAT or mMRC'}}
                    </td>
                    <td>
                        <ul>
                            <li v-if="questionMap[10].value[1] " v-html="questionMap[10].configMap[1].inputs[questionMap[10].value[1]].label[$language()]"/>
                            <li v-if="questionMap[11].value[1] " v-html="questionMap[11].configMap[1].inputs[questionMap[11].value[1]].label[$language()]"/>
                            <li v-if="questionMap[12].value[1] " v-html="questionMap[12].configMap[1].inputs[questionMap[12].value[1]].label[$language()]"/>
                        </ul>
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Dyspnée persistante' : 'Persistent dyspnea'}}
                    </td>
                    <td>
                        <ul>
                            <li v-if="questionMap[18].value[1] " v-html="questionMap[18].configMap[1].inputs[questionMap[18].value[1]].label[$language()]"/>
                        </ul>                    
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Antibiotique ou corticostéroïdes oraux pour les symptômes respiratoires au cours des 12 derniers mois' : 'Antibiotic or oral corticosteroids for respiratory symptoms in the past year'}}
                    </td>
                    <td>
                        <ul>
                            <li v-if="questionMap[19].value[1] ">{{questionMap[19].configMap[1].inputs[questionMap[19].value[1]].label[$language()]}}</li>                 
                        </ul>                    
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Hospitalisation ou visite à l’urgence pour des symptômes respiratoires au cours des 12 derniers mois' : 'Hospitalization or emergency department visit for respiratory symptoms in the past year'}}
                    </td>
                    <td>
                        <ul>
                            <li v-if="questionMap[20].value[1] " v-html="questionMap[20].configMap[1].inputs[questionMap[20].value[1]].label[$language()]"/>
                        </ul>                    
                    </td>
                </tr>

                <tr>
                    <th colspan='2'>
                        {{$language()=='fr' ? 'Information sur le traitement' : 'Treatment Information'}}                    	
                    </th>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Traitement actuel' : 'Current treatment '}}
                    </td>
                    <td>
                        <ul>
                            <li v-if="questionMap[15].value[1] " v-html="questionMap[15].configMap[1].inputs[questionMap[15].value[1]].label[$language()]"/>
                        </ul>                    
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Traitements pour inhalation envisagés' : 'Inhaled therapies you are considering'}}
                    </td>
                    <td>
                        <template v-if="q23_selections.length==0">
                            {{$language()=='fr' ? 'Vous avez indiqué ne pas envisager de changement de traitement.' : 'You indicated that you are not considering a change of therapy.'}}
                        </template>
                        <template v-else>
                            {{$language()=='fr' ? 'Vous avez mentionné que vous envisagez les traitements suivants pour ce patient :' : 'You indicated for this patient you were considering the following therapies:'}}
                            <ul>
                                <template v-for="(selected,index) in q23_selections">
                                    <li :key="'q23_index_'+index" v-html="selected"/>
                                </template>                
                            </ul>
                        </template>
                    </td>
                </tr>

                <tr>
                    <td>
                        {{$language()=='fr' ? 'Autres mesures additionnelles envisagées' : 'Additional actions you are considering '}}
                    </td>
                    <td>
                        <template v-if="questionMap[24].value[1].length==0">
                            {{$language()=='fr' ? 'Aucune autre mesure ou évaluation' : 'No other actions or assessments'}}
                        </template>
                        <template v-else>
                            {{$language()=='fr' ? 'Vous avez mentionné que vous envisagez les mesures additionnelles suivantes pour ce patient :' : 'You indicated for this patient you were considering the following additional actions:'}}
                            <ul>
                                <template v-for="(selected,index) in q24_selections">
                                    <li :key="'q24_index_'+index" v-html="selected"/>
                                </template>                
                            </ul>
                        </template>  
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <center>
        <v-btn small color="primary" v-if="!download" @click="download=!download" style="margin: 25px;">
            <str :index="'button > download'"/>
        </v-btn>
    </center>
    
    <pdf v-if="download" :filename="'patient_summary'" :htmlCode="htmlCode()" @close="download=false"/>
</div>
</template>

<script>
import pdf from '@/components/Print/Print.vue';

export default {
    props: {
        questionMap: {
            type: Object,
            required: true
        }
    },
    components: {
        pdf
    },
    created: function(){
        var self = this;
        setTimeout(function(){
            self.ready = true;
        },1000)
    },
    data: function(){
        return {
            ready: false,
            download: false
        }
    },
    methods: {
        htmlCode: function(){
            var source = this.$refs.source;
            return source.innerHTML;
        }
    },
    computed: {
        q23_selections: function(){
            var question = this.questionMap[23];
            var inputMap = {};
            for(let i in question.config.groups[0].inputs){
                let input = question.config.groups[0].inputs[i];
                inputMap[input.id] = input.label[this.$language()];
            }

            var selections = [];
            if(question && question.value[1]){
                let value = question.value[1];
                selections.push(inputMap[value]);
            }
            return selections;
        },
        q24_selections: function(){
            var question = this.questionMap[24];
            var inputMap = {};
            for(let i in question.config.groups[0].inputs){
                let input = question.config.groups[0].inputs[i];
                inputMap[input.id] = input.label[this.$language()];
            }

            var selections = [];
            if(question && question.value[1] && question.value[1].length>0){
                for(let i=0; i<question.value[1].length; i++){
                    let value = question.value[1][i];
                    selections.push(inputMap[value]);
                }
            }
            return selections;
        }
    }
}
</script>

<style module>
.sourceTable {
    margin: 0 auto;
    width: 100%;
    max-width: 1024px;
    border-collapse: collapse;
}

.sourceTable th, .sourceTable td {
    vertical-align: top;
    border: 1px solid black;
    padding: 0.5rem;
}

.sourceTable th {
    background-color: #00a4c0;
    color: white;
    font-size: 20px;
    font-weight: 300;
    padding: 1.5% 0;
}

.sourceTable tr td:first-child {
    color: black;
    font-weight: 500;
}
</style>

